import { ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import useClient from '../client/apiClient'

export default function useMPrecios() {

  const client = useClient()

  const mprecio = ref([])
  const mprecios = ref([])

  const tmovimientos = ref([])
  const tcamiones = ref([])
  const origenes = ref([])
  const destinos = ref([])

  const dt = ref({})
  const loading = ref(false)
  const saving = ref(false)

  const selectedMPrecios = ref()
  const selectedTMovimientos = ref()
  const selectedTCamiones = ref()
  const deleteMPreciosDialog = ref(false)
  const deleteMPrecioDialog = ref(false)
  const mprecioDialog = ref(false)
  const submitted = ref(false)

  const filteredTMovimientos = ref()
  const filteredDestinos = ref()
  const filteredOrigenes = ref()
  const filteredTCamiones = ref()

  const getCRUD = async () => {
    loading.value = true
    client.get(`/api/mprecios/all/crud`).then(response => {
      mprecios.value = response.data.data.mprecios
      origenes.value = response.data.data.origenes
      destinos.value = response.data.data.destinos
      tmovimientos.value = response.data.data.tmovimientos
      tcamiones.value = response.data.data.tcamiones
      loading.value = false
    })
  }

  const storeMPrecio = async (form) => {
    saving.value = true
    let id = mprecio.value.id
    if (id) {
      //Esta editando el registro
      client.put(`/api/mprecios/${id}`, { 'data': { ...form } })
        .then(() => {
          saving.value = !saving.value
          mprecioDialog.value = false
          //client.saving.value = false ?? getCRUD()
          getCRUD()
        })
    } else {
      //Esta creando el registro
      client.post(`/api/mprecios`, { 'data': { ...form } })
      .then(() => {
        mprecioDialog.value = client.dialog.value
        mprecio.value = client.entity.value
        saving.value = client.saving.value
        getCRUD()
      })
    }
  }

  const deleteMPrecio = async () => {
    client.remove(`/api/mprecios/${mprecio.value.id}`)
      .then(response => {
        mprecios.value = mprecios.value.filter(val => val.id !== mprecio.value.id)
        deleteMPrecioDialog.value = false
        mprecio.value = {}
      })
  }

  const filters = ref({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },

    'id': { value: null, matchMode: FilterMatchMode.EQUALS },
    'tmovimiento.nombre': { value: null, matchMode: FilterMatchMode.EQUALS },
    'tcamion.nombre': { value: null, matchMode: FilterMatchMode.EQUALS },
    'origen.descripcion': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'destino.descripcion': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'precio': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'fecha': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'vigente': { value: null, matchMode: FilterMatchMode.EQUALS }  
  })

  return {
    mprecio,
    mprecios,
    tmovimientos,
    tcamiones,
    origenes,
    destinos,
    dt,
    loading,
    saving,
    filters,
    selectedMPrecios,
    selectedTMovimientos,
    selectedTCamiones,
    deleteMPreciosDialog,
    deleteMPrecioDialog,
    mprecioDialog,
    submitted,
    filteredTMovimientos,
    filteredDestinos,
    filteredOrigenes,
    filteredTCamiones,
    getCRUD,
    storeMPrecio,
    deleteMPrecio
  }
}